<template>
    <div v-if="componentShow">
        <el-input ref="callInput" v-model="inpValue" class="input-with-select" :disabled="disabled" :tabindex="tabindex"
                  :class="{'zm-call-big-input': callType == 'big','zm-call-small-input':callType == 'small'}" @focus="inputFocus" onkeypress="if(event.keyCode == 13) return false;"
                  :name="name" @keyup.enter.native="inputEnter"  @keydown.tab.native="tabEnter"  @blur="inputBlur" style="margin-top: -4px;">
            <div slot="append" style="display: inline-flex;" v-if="showLabel">
                <div style="float: left;width: 46px;">
                    <el-button icon="el-icon-search" @click="openDialog" style="border-right: 1px solid #e4e6eb;" :disabled="disabled" tabindex="-1"></el-button>
                </div>

                <div style="overflow: hidden;margin-right: -13px;" :style="{width:nameWidth + 'px','margin-left':nameML+ 'px'}" tabindex="-1">
                    <el-tooltip :tabindex=-1 :disabled="tooldis" class="item" effect="dark" :content="inpLable" placement="top" >
                        <span style="text-align: left;" tabindex="-1">{{inpLable}}</span>
                    </el-tooltip>
                    <!--<el-input style="width: 216px" :disabled=true v-model="inpLable"></el-input>-->
                    <!--<template >
                        <div style="width: 216px">{{inpLable}}</div>
                    </template>-->
                </div>
            </div>
            <el-button icon="el-icon-search" @click="openDialog" slot="append" v-else :disabled="disabled" tabindex="-1"></el-button>
        </el-input>
        <el-dialog v-dialogDrag :title="$t(i18nPage+title)" width="720px" :close-on-click-modal="false" :visible.sync="inpDialog" :before-close="dialogClose" :append-to-body="true">
            <div class="dialog-content dialog-content-medium">
                <div class="dialog-main">
                    <el-row :gutter=8>
                        <el-col :span=20>
                            <el-input v-model="queryVal" ref="queryInput"/>
                        </el-col>
                        <el-col :span=4>
                            <el-button type="primary" @click="refreshTableList" :loading="refreshLoad">{{$t(i18nPage+'刷新')}}</el-button>
                        </el-col>
                    </el-row>
                    <el-container style="margin-top: 10px">
                        <el-main>
                            <el-table :data="tableData" border ref="zmtable" height="380" highlight-current-row @current-change="handleCurrentChange" stripe
                                      @row-dblclick="rowDbClick">
                                <el-table-column type="index" width="52"  align="center">
                                    <template slot="header" slot-scope="scope">
                                        <span>{{$t(i18nPage+'序号')}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column v-for="(column,index) in col" :key="index" :label="column.text" :prop="column.value"
                                                 :width="column.width" :show-overflow-tooltip=true >
                                </el-table-column>
                            </el-table>
                        </el-main>
                        <el-footer class="el-footer-cls">
                            <el-pagination
                                    @size-change="pageSizeChange"
                                    @current-change="pageCurrentChange"
                                    :current-page="pagobj.currentPage"
                                    :page-sizes="[50, 100, 200, 300]"
                                    :page-size="pagobj.pageSize"
                                    layout="prev,  pager, next, jumper, sizes, total"
                                    :total="pagobj.total">
                            </el-pagination>
                        </el-footer>
                    </el-container>
                </div>
                <div class="dialog-btn">
                    <el-button type=primary @click="checkRow">{{$t(i18nPage+'选取')}}</el-button>
                    <el-button type=info @click="dialogClose">{{$t(i18nPage+'取消')}}</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: "ZmCallTable",
        props: {
            tableName:{
                type:String
            },
            value:{
                type:[String,Number,Array]
            },
            defaultExtra:{
                type:[String,Number]
            },
            showLabel:{
                type:Boolean,
                default:true
            },
            labelWidth:{
                type:Number,
                default:183
            },
            title:{
                type:String,
                default:'查找'
            },
            name:{
                type:String
            },
            isEnterNext:{
                type:Boolean,
                default:false
            },
            callType:{
                type:String,
                default:'big'
            },
            disabled:{
                type:Boolean,
                default:false
            },
            tabindex:{
                type:String
            },
            isLocalData:{
                type:Boolean,
                default:false
            },
            getCallData:{
                type:Function
            },
            isSelfWidth:{
                type:Boolean,
                default:false
            },
            isDefaultValid:{
                type:Boolean,
                default:true
            }
        },
        beforeCreate() {
            this.i18nPage = 'component.zmCallTable.';
        },
        data(){
            return {
                i18nPage : 'component.zmCallTable.',
                refreshLoad:false,
                pagobj:{
                    total:0,
                    pageSize:50,
                    currentPage:1
                },
                inpLable:'',
                inpValue:'',
                tmpInpValue:'',
                tabInpValue:'',
                enterTabFlag:false,
                callValue:'',
                callLabel:'',
                callNo:'',
                callText:'',
							tableDetails: [],
                inpDialog:false,
                queryVal:'',
                queryLoading:false,
                col:[],
                tableData:[],
                selRow:null,
                callTableList:[],
                tooldis:true,
                inputRow:null,
                componentShow:true,
                isEnter:false,
                nameWidth:183,
                nameML:-26,
                tempExtra:'',
                initCount:0
            }
        },
        computed:{
            newValue: {
                get:function() {
                    return this.value;
                },
                set:function(value) {
                    this.$emit('input', value);
                }
            }
        },
        methods: {
            refreshTableList(){
                this.refreshLoad = true;
                let tempQuery = this.queryVal;
                this.queryVal = '';
                let extra = this.tempExtra ? this.tempExtra : this.defaultExtra;
                if(this.tableName){
                    extra ? this.$util.remove('tf:'+ this.tableName+':'+extra) : this.$util.remove('tf:'+ this.tableName);
                }
                if(this.isLocalData){
                    if(this.getCallData){
                        this.getCallData().then((res) => {
                            this.refreshLoad = false;
                            this.setLocalData(res);
                            this.queryVal = tempQuery;
                        }).catch(() => {
                            this.refreshLoad = false;
                        });
                    }
                }else{
                    this.$global.getTransferTable(this.tableName,extra).then((res) => {
                        this.refreshLoad = false;
                        this.callTableList = res;
                        this.queryVal = tempQuery;
                    }).catch(() => {
                        this.refreshLoad = false;
                    });
                }

            },
            setValue(val){
                if(!val){
                    this.clean();
                    return;
                }
                if(this.callTableList && this.callTableList.length > 0){
                    let flag = true;
                    for(let i = 0;i<this.callTableList.length;i++){
                        if(this.callTableList[i][this.callValue] == val){
                            flag = false;
                            this.newValue = val;
                            this.inputRow = this.callTableList[i];
                            this.inpLable = this.callTableList[i][this.callLabel];
                            this.inpValue = this.callTableList[i][this.callNo];
                            this.$emit('change',this.callTableList[i]);
                            break;
                        }
                    }
                    if(flag){
                        this.clean();
                    }
                }else{
                    if(this.isLocalData){
                        if(this.getCallData){
                            this.getCallData().then((res) => {
                                this.setLocalData(res);
                                // this.callTableList = res;
                                if(res && res.length > 0){
                                    let flag = true;
                                    for(let i = 0;i<res.length;i++){
                                        if(res[i][this.callValue] == val){
                                            flag = false;
                                            this.newValue = val;
                                            this.inputRow = this.callTableList[i];
                                            this.inpLable = res[i][this.callLabel];
                                            this.inpValue = res[i][this.callNo];
                                            this.$emit('change',this.callTableList[i]);
                                            break;
                                        }
                                    }
                                    if(flag){
                                        this.clean();
                                    }
                                }else{
                                    this.clean();
                                }
                            });
                        }else{
                            this.clean();
                        }
                    }else{
                        this.$global.getTransferTable(this.tableName,this.defaultExtra).then((res) => {
                            this.callTableList = res;
                            if(res && res.length > 0){
                                let flag = true;
                                for(let i = 0;i<res.length;i++){
                                    if(res[i][this.callValue] == val){
                                        flag = false;
                                        this.newValue = val;
                                        this.inputRow = this.callTableList[i];
                                        this.inpLable = res[i][this.callLabel];
                                        this.inpValue = res[i][this.callNo];
                                        this.$emit('change',this.callTableList[i]);
                                        break;
                                    }
                                }
                                if(flag){
                                    this.clean();
                                }
                            }else{
                                this.clean();
                            }
                        });
                    }
                }
            },
            setLocalData(res){
                if(res && res.length > 0){
                    for(let i = 0;i<res.length;i++){
                        res[i]['text'] =  res[i][this.callLabel] + '(' + res[i][this.callValue] + ')'
                    }
                    this.callTableList = res;
                }else{
                    this.callTableList = [];
                }
            },
            clean(){
                this.newValue = '';
                this.inpLable = '';
                this.inpValue = '';
                this.inputRow = null;
            },
            getTableList(extra,val){
                return new Promise((resolve,reject) => {
                    if(!extra){
                        this.tempExtra = '';
                        resolve('');
                    }else{
                        this.tempExtra = extra;
                        this.clean();
                        this.callTableList = [];
                        this.tableData = [];
                        if(this.isLocalData){
                            if(this.getCallData){
                                this.getCallData().then(res => {
                                    this.setLocalData(res);
                                    // this.callTableList = res;
                                    if (val) {
                                        this.setValue(val);
                                    }
                                    resolve(this.inputRow);
                                })
                            }
                        }else {
                            this.$global.getTransferTable(this.tableName, extra).then((res) => {
                                this.callTableList = res;
                                if (val) {
                                    this.setValue(val);
                                }
                                resolve(this.inputRow);
                            });
                        }
                    }
                });
            },
					getCallTableDetail(){
						let callTableDetailInfo = this.$util.get("callTableDetailInfo");
						console.log(callTableDetailInfo)
						console.log( this.tableName)
						if (callTableDetailInfo && callTableDetailInfo.length > 0){
							callTableDetailInfo.forEach((calltableDetail, index) => {
								if (calltableDetail['tableNo'] == this.tableName && calltableDetail['fieldNo'] && calltableDetail['fieldName']){
									this.tableDetails.push(calltableDetail)
								}
							});
						}
					},
            callTableInit(){
                if(this.tableName){
                    let callTableInfo = this.$util.get("callTableInfo");
                    if(callTableInfo){
                        let calltable = callTableInfo[this.tableName];
                        this.callValue = calltable.value;
                        this.callLabel = calltable.label;
                        this.callNo = calltable.no;
                        this.callText = calltable.no ? 'text' : calltable.label;
                        // console.log(this.callText)
											this.getCallTableDetail();
											console.log(this.tableDetails)
											if(this.tableDetails && this.tableDetails.length > 0){
												this.tableDetails.forEach((detail,index) => {
													this.col.push({value: detail['fieldNo'],text: detail['fieldName'],width: detail['width'] || 100});
												})
											}else {
												this.col.push({value: calltable.no,text: this.$t(this.i18nPage+'编码'),width: 200});
												this.col.push({value: calltable.label,text: this.$t(this.i18nPage+'名称'),width: 380});
											}
                        if(this.newValue){
                            if(this.isLocalData){
                                if(this.getCallData){
                                    this.getCallData().then(res => {
                                        this.setLocalData(res);
                                        // this.callTableList = res;
                                        if (res && res.length > 0) {
                                            for (let i = 0; i < res.length; i++) {
                                                if (res[i][this.callValue] == this.newValue) {
                                                    this.inpLable = res[i][this.callLabel];
                                                    this.inpValue = res[i][this.callNo];
                                                    break;
                                                }
                                            }
                                        }
                                    })
                                }
                            }else {
                                this.$global.getTransferTable(this.tableName, this.defaultExtra).then((res) => {
                                    this.callTableList = res;
                                    if (res && res.length > 0) {
                                        for (let i = 0; i < res.length; i++) {
                                            if (res[i][this.callValue] == this.newValue) {
                                                this.inpLable = res[i][this.callLabel];
                                                this.inpValue = res[i][this.callNo];
                                                break;
                                            }
                                        }
                                    }
                                });
                            }
                        }
                    }else{
                        if(this.initCount < 10){
                            setTimeout(() => {
                                this.initCount ++;
                                this.callTableInit();
                            },5000)
                        }else{
                            this.$util.show(this.$t(this.i18nPage+'调用表配置加载失败'),1)
                        }
                    }
                }
            },
            inputEnter(){
                this.isEnter = true;
                if(!this.inpDialog){
                    // console.log("输入框回车")
                    if(this.isEnterNext && this.tmpInpValue){
                        this.inpValue = this.tmpInpValue;
                    }
                    if(this.inpValue && $.trim(this.inpValue)){
                        this.inpValue = $.trim(this.inpValue);
                        if(this.callTableList && this.callTableList.length > 0){
                            let templist = [];
                            for(let i = 0;i < this.callTableList.length;i++){
                                let item = this.callTableList[i];
                                if(this.callNo && (item[this.callNo] == this.inpValue || item[this.callNo].toUpperCase() == this.inpValue.toUpperCase())){
                                    templist = [];
                                    templist.push(item);
                                    break;
                                }
                                if (item[this.callText].indexOf(this.inpValue) > -1 || item[this.callText].toUpperCase().indexOf(this.inpValue.toUpperCase()) > -1) {
                                    templist.push(item);
                                }

                            }
                            /*let templist = this.callTableList.filter((item) => {
                                if (item[this.callText].indexOf(this.inpValue) > -1 || item[this.callText].toUpperCase().indexOf(this.inpValue.toUpperCase()) > -1) {
                                    return true
                                }
                            });*/
                            this.setCallTable(templist);
                        }else{
                            if(this.isLocalData){
                                if(this.getCallData){
                                    this.getCallData().then(res => {
                                        this.setLocalData(res);
                                        // this.callTableList = res;
                                        if (res && res.length > 0) {
                                            let templist = [];
                                            for (let i = 0; i < res.length; i++) {
                                                let item = res[i];
                                                if (this.callNo && (item[this.callNo] == this.inpValue || item[this.callNo].toUpperCase() == this.inpValue.toUpperCase())) {
                                                    templist = [];
                                                    templist.push(item);
                                                    break;
                                                }
                                                if (item[this.callText].indexOf(this.inpValue) > -1 || item[this.callText].toUpperCase().indexOf(this.inpValue.toUpperCase()) > -1) {
                                                    templist.push(item);
                                                }
                                            }
                                            this.setCallTable(templist);
                                        } else {
                                            this.setCallTable();
                                        }
                                    })
                                }
                            }else {
                                this.$global.getTransferTable(this.tableName, this.defaultExtra).then((res) => {
                                    this.callTableList = res;
                                    if (res && res.length > 0) {
                                        let templist = [];
                                        for (let i = 0; i < res.length; i++) {
                                            let item = res[i];
                                            if (this.callNo && (item[this.callNo] == this.inpValue || item[this.callNo].toUpperCase() == this.inpValue.toUpperCase())) {
                                                templist = [];
                                                templist.push(item);
                                                break;
                                            }
                                            if (item[this.callText].indexOf(this.inpValue) > -1 || item[this.callText].toUpperCase().indexOf(this.inpValue.toUpperCase()) > -1) {
                                                templist.push(item);
                                            }
                                        }
                                        /*let templist = res.filter((item) => {
                                        if (item[this.callText].indexOf(this.inpValue) > -1 || item[this.callText].toUpperCase().indexOf(this.inpValue.toUpperCase()) > -1) {
                                            return true
                                        }
                                    });*/
                                        this.setCallTable(templist);
                                    } else {
                                        this.setCallTable();
                                        // this.inpLable = '';
                                        // this.newValue = '';
                                    }
                                });
                            }
                        }
                    }else{
                        if(this.isDefaultValid){
                            this.setCallTable();
                        }else{
                            this.clean();
                            // this.inputRow = null;
                            // this.inpLable = '';
                            // this.inpValue = '';
                            // this.newValue = '';
                        }
                        // this.setCallTable();
                        // this.inpLable = '';
                        // this.newValue = '';
                    }
                }




            },
            tabEnter(event,type){
                console.log(type)
                // console.log('tabEnter')
                if(!type || type != 'blur'){
                    this.enterTabFlag = true;
                }
                // this.inpValue;
                // let that = this;
                // console.log(this.tabInpValue);
                // this.inpValue = this.tabInpValue;
                if(this.inpValue && $.trim(this.inpValue)){
                    this.inpValue = $.trim(this.inpValue);
                    if(this.callTableList && this.callTableList.length > 0){
                        let templist = [];
                        for(let i = 0;i < this.callTableList.length;i++){
                            let item = this.callTableList[i];
                            if(this.callNo && (item[this.callNo] == this.inpValue || item[this.callNo].toUpperCase() == this.inpValue.toUpperCase())){
                                templist = [];
                                templist.push(item);
                                break;
                            }
                            if (item[this.callText].indexOf(this.inpValue) > -1 || item[this.callText].toUpperCase().indexOf(this.inpValue.toUpperCase()) > -1) {
                                templist.push(item);
                            }

                        }
                        this.setCallTable(templist);
                    }else{
                        if(this.isLocalData){
                            if(this.getCallData){
                                this.getCallData().then(res => {
                                    this.setLocalData(res);
                                    // this.callTableList = res;
                                    if (res && res.length > 0) {
                                        let templist = [];
                                        for (let i = 0; i < res.length; i++) {
                                            let item = res[i];
                                            if (this.callNo && (item[this.callNo] == this.inpValue || item[this.callNo].toUpperCase() == this.inpValue.toUpperCase())) {
                                                templist = [];
                                                templist.push(item);
                                                break;
                                            }
                                            if (item[this.callText].indexOf(this.inpValue) > -1 || item[this.callText].toUpperCase().indexOf(this.inpValue.toUpperCase()) > -1) {
                                                templist.push(item);
                                            }
                                        }
                                        this.setCallTable(templist);
                                    } else {
                                        this.setCallTable();
                                    }
                                })
                            }
                        }else {
                            if(this.isLocalData){
                                if(this.getCallData){
                                    this.getCallData().then(res => {
                                        this.setLocalData(res);
                                        // this.callTableList = res;
                                        if (res && res.length > 0) {
                                            let templist = [];
                                            for (let i = 0; i < res.length; i++) {
                                                let item = res[i];
                                                if (this.callNo && (item[this.callNo] == this.inpValue || item[this.callNo].toUpperCase() == this.inpValue.toUpperCase())) {
                                                    templist = [];
                                                    templist.push(item);
                                                    break;
                                                }
                                                if (item[this.callText].indexOf(this.inpValue) > -1 || item[this.callText].toUpperCase().indexOf(this.inpValue.toUpperCase()) > -1) {
                                                    templist.push(item);
                                                }
                                            }
                                            this.setCallTable(templist);
                                        } else {
                                            this.setCallTable();
                                        }
                                    })
                                }
                            }else {
                                this.$global.getTransferTable(this.tableName, this.defaultExtra).then((res) => {
                                    this.callTableList = res;
                                    if (res && res.length > 0) {
                                        let templist = [];
                                        for (let i = 0; i < res.length; i++) {
                                            let item = res[i];
                                            if (this.callNo && (item[this.callNo] == this.inpValue || item[this.callNo].toUpperCase() == this.inpValue.toUpperCase())) {
                                                templist = [];
                                                templist.push(item);
                                                break;
                                            }
                                            if (item[this.callText].indexOf(this.inpValue) > -1 || item[this.callText].toUpperCase().indexOf(this.inpValue.toUpperCase()) > -1) {
                                                templist.push(item);
                                            }
                                        }
                                        this.setCallTable(templist);
                                    } else {
                                        this.setCallTable();
                                    }
                                });
                            }
                        }
                    }
                }else{
                    if(this.isDefaultValid){
                        this.setCallTable();
                    }else{
                        this.clean();
                        // this.inputRow = null;
                        // this.inpLable = '';
                        // this.inpValue = '';
                        // this.newValue = '';
                    }
                    // this.setCallTable();
                }
            },
            inputFocus(){
                this.$emit('focus','');
            },
            inputBlur(envnt){
                this.$emit('blur','');
                // console.log(envnt)
                // console.log('inputBlur')
                if(!this.enterTabFlag){
                    // this.tabInpValue = this.inpValue;
                    if(this.isEnterNext){
                        this.tmpInpValue = this.inpValue;
                        let that = this;
                        setTimeout(() => {
                            that.tmpInpValue = '';
                            if(that.isEnter){
                                that.isEnter = false;
                            }else{
                                // console.log('inner Blur');
                                if(that.inpValue && $.trim(that.inpValue)){
                                    that.tabEnter('','blur');
                                }else{
                                    that.inputRow = null;
                                    that.inpLable = '';
                                    that.inpValue = '';
                                    that.newValue = '';
                                }
                            }
                        },100)
                    }else{
                        if(this.inpValue && $.trim(this.inpValue)){
                            this.tabEnter('','blur');
                        }else{
                            this.clean();
                            // this.inputRow = null;
                            // this.inpLable = '';
                            // this.inpValue = '';
                            // this.newValue = '';
                        }
                    }
                    /*if(this.inputRow && this.inputRow[this.callValue]){
                        if(this.inputRow[this.callNo] != this.inpValue){
                            this.inputRow = null;
                            this.inpLable = '';
                            this.inpValue = '';
                            this.newValue = '';
                        }
                    }else{
                        this.inputRow = null;
                        this.inpLable = '';
                        this.inpValue = '';
                        this.newValue = '';
                    }*/
                }else{
                    this.enterTabFlag = false;
                }


                // console.log(1);

            },
            setCallTable(res){
                if(res && res.length > 0){
                    if(res.length === 1){
                        this.inputRow = res[0];
                        if(this.newValue != res[0][this.callValue]){
                            this.$emit('change',res[0]);
                        }
                        this.inpLable = res[0][this.callLabel];
                        this.inpValue = res[0][this.callNo];
                        this.newValue = res[0][this.callValue];
                    }else{
                        this.inputRow = null;
                        this.$emit('change',{});
                        this.inpLable = '';
                        this.newValue = '';
                        this.queryVal = this.inpValue;

                        this.pagobj.total = res.length;
                        this.pagobj.currentPage = 1;
                        if(res.length > this.pagobj.pageSize){
                            this.tableData = res.slice(0,this.pagobj.pageSize);
                        }else{
                            this.tableData = res;
                        }
                        this.inpValue = '';
                        this.inpDialog = true;
                        this.$nextTick(() => {
                            let that = this;
                            setTimeout(() => {
                                if(this.inpDialog){
                                    // console.log('开启监听')
                                    document.addEventListener('keydown', that.keyupListener);
                                }

                            },200);
                            if(this.tableData && this.tableData.length > 0){
                                // console.log("选择第一条数据")
                                this.$refs['zmtable'].setCurrentRow(this.tableData[0]);
                            }
                        });
                        // this.$util.show("返回多条数据,即将弹窗！")
                    }
                }else{
                    /*if(this.isEnterNext){
                        this.inpValue = '';
                    }
                    console.log('setCallTable')*/
                    if(this.inpDialog){
                        this.inpValue = '';
                        this.$refs['queryInput'].focus();
                    }else{
                        this.$util.show(this.$t(this.i18nPage+'未查询到数据'),1);
                        setTimeout(() => {
                            this.$refs['callInput'].select();
                        },50);
                    }
                    this.inputRow = null;
                    this.$emit('change',{});
                    this.inpLable = '';
                    this.newValue = '';
                }
            },
            keyupListener(e){
                if(e.keyCode === 13){
                    this.$refs['callInput'].focus();
                    // console.log('enter 13')
                    this.checkRow();
                }
                if(e.keyCode === 38){
                    if(this.tableData && this.tableData.length > 0){
                        if(this.selRow){
                            let selRowIndex = this.tableData.indexOf(this.selRow);
                            if(selRowIndex > -1){
                                if(selRowIndex > 0){
                                    // this.$refs['zmtable'].setCurrentRow(this.tableData[selRowIndex -1]);
                                    this.setTbCurrentRow(selRowIndex -1,1);
                                }
                            }else{
                                // this.$refs['zmtable'].setCurrentRow(this.tableData[0]);
                                this.setTbCurrentRow(0,1);
                            }
                        }else{
                            // this.$refs['zmtable'].setCurrentRow(this.tableData[0]);
                            this.setTbCurrentRow(0,1);
                        }
                    }
                }
                if(e.keyCode === 40){
                    if(this.tableData && this.tableData.length > 0){
                        if(this.selRow){
                            let selRowIndex = this.tableData.indexOf(this.selRow);
                            if(selRowIndex > -1){
                                if(selRowIndex < this.tableData.length -1){
                                    // this.$refs['zmtable'].setCurrentRow(this.tableData[selRowIndex + 1]);
                                    this.setTbCurrentRow(selRowIndex + 1,2);
                                }
                            }else{
                                // this.$refs['zmtable'].setCurrentRow(this.tableData[0]);
                                this.setTbCurrentRow(0,2);
                            }
                        }else{
                            // this.$refs['zmtable'].setCurrentRow(this.tableData[0]);
                            this.setTbCurrentRow(0,2);
                        }
                    }
                }
            },
            setTbCurrentRow(i,type) {
                this.$refs['zmtable'].setCurrentRow(this.tableData[i]);
                const targetTop = this.$refs['zmtable'].$el.querySelectorAll('.el-table__body tr')[i].getBoundingClientRect().top;
                const containerTop = this.$refs['zmtable'].$el.querySelector('.el-table__body').getBoundingClientRect().top;
                let stop = 0;
                if(type == 2){
                    stop = targetTop - containerTop-321;
                }else{
                    stop = targetTop - containerTop;
                }
                if(stop >= 0){
                    const scrollParent = this.$refs['zmtable'].$el.querySelector('.el-table__body-wrapper');
                    scrollParent.scrollTop = targetTop - 160 - containerTop;
                }else{
                    const scrollParent = this.$refs['zmtable'].$el.querySelector('.el-table__body-wrapper');
                    scrollParent.scrollTop = 0;
                }
                // 330

            },

            openDialog(){
                if(!this.inpDialog){
                    // this.inpValue = '';
                    this.inpDialog = true;
                    this.queryVal = '';
                    if(!this.callTableList || this.callTableList.length == 0){
                        if(this.isLocalData){
                            if(this.getCallData){
                                this.getCallData().then(res => {
                                    this.setLocalData(res);
                                    // this.callTableList = res;
                                    this.$nextTick(() => {
                                        this.$refs['queryInput'].focus();
                                        document.addEventListener('keydown', this.keyupListener);
                                        this.queryEnter();
                                    })
                                })
                            }
                        }else {
                            this.$global.getTransferTable(this.tableName, this.defaultExtra).then((res) => {
                                this.callTableList = res;
                                this.$nextTick(() => {
                                    this.$refs['queryInput'].focus();
                                    document.addEventListener('keydown', this.keyupListener);
                                    this.queryEnter();
                                })
                            });
                        }
                    }else{
                        this.$nextTick(() => {
                            this.$refs['queryInput'].focus();
                            document.addEventListener('keydown', this.keyupListener);
                            this.queryEnter();
                        })
                    }
                }
            },
            dialogClose(){
                if(!this.newValue){
                    this.inpLable = '';
                    this.newValue = '';
                    this.$refs['callInput'].focus();
                }
                // console.log('移除监听')
                document.removeEventListener('keydown',this.keyupListener);
                this.inpDialog = false;
            },
            queryEnter(val){
                let start = 0;
                let end = 50;
                if(val){
                    start = (this.pagobj.currentPage-1) * this.pagobj.pageSize;
                    end = this.pagobj.currentPage * this.pagobj.pageSize;
                }else{
                    this.pagobj.currentPage = 1;
                    end = this.pagobj.pageSize;
                }

                if(this.queryVal){
                    if(this.callTableList && this.callTableList.length > 0){
                        let tmpList = this.callTableList.filter((item) => {
                        	if (this.tableDetails && this.tableDetails.length > 0){
														for (let i = 0; i < this.tableDetails.length; i++) {
															let detail = this.tableDetails[i]
															if(item[detail['fieldNo']]){
																if(item[detail['fieldNo']].indexOf(this.queryVal) > -1 || item[detail['fieldNo']].toUpperCase().indexOf(this.queryVal.toUpperCase()) > -1){
																	return true
																}
															}
														}
													}else {
														if (item[this.callText].indexOf(this.queryVal) > -1 || item[this.callText].toUpperCase().indexOf(this.queryVal.toUpperCase()) > -1) {
															return true
														}
													}
                        });
                        this.pagobj.total = tmpList.length;
                        if(tmpList.length > this.pagobj.pageSize){
                            end = end > tmpList.length ? tmpList.length : end;
                            this.tableData = tmpList.slice(start,end);
                        }else{
                            this.tableData = tmpList;
                        }
                    }else{
                        this.tableData = [];
                        this.pagobj.total = 0;
                    }
                }else{
                    if(this.callTableList && this.callTableList.length > 0){
                        this.pagobj.total = this.callTableList.length;
                        if(this.callTableList.length > this.pagobj.pageSize){
                            end = end > this.callTableList.length ? this.callTableList.length : end;
                            this.tableData = this.callTableList.slice(start,end);
                        }else{
                            this.tableData = this.callTableList;
                        }
                    }else{
                        this.tableData = [];
                        this.pagobj.total = 0;
                    }
                }
                if(this.tableData && this.tableData.length > 0){
                    if(this.$refs['zmtable']){
                        this.$refs['zmtable'].setCurrentRow(this.tableData[0]);
                    }else{
                        this.$nextTick(() => {
                            this.$refs['zmtable'].setCurrentRow(this.tableData[0]);
                        });
                    }

                }

            },
            handleCurrentChange(val) {
                this.selRow = val;
            },
            rowDbClick(row){
                this.inputRow = row;
                if(this.newValue != row[this.callValue]){
                    this.$emit('change',row);
                }
                this.inpLable = row[this.callLabel];
                this.inpValue = row[this.callNo];
                this.newValue = row[this.callValue];
                // console.log('移除监听')
                document.removeEventListener('keydown',this.keyupListener)
                this.inpDialog = false;
            },
            pageSizeChange(val) {
                this.pagobj.pageSize = val;
                this.queryEnter(true);
            },
            pageCurrentChange(val) {
                this.pagobj.currentPage = val;
                this.queryEnter(true);
            },
            checkRow(){
                if(this.selRow){
                    // console.log(this.selRow)
                    this.inputRow = this.selRow;
                    if(this.newValue != this.selRow[this.callValue]){
                        this.$emit('change',this.selRow);
                    }
                    this.inpLable = this.selRow[this.callLabel];
                    this.inpValue = this.selRow[this.callNo];
                    this.newValue = this.selRow[this.callValue];
                    // console.log('移除监听')
                    document.removeEventListener('keydown',this.keyupListener)
                    this.inpDialog = false;
                }else{
                    this.$util.show(this.$t(this.i18nPage+"请选择数据"),1);
                }
            },
            focus(){
                this.$refs['callInput'].focus();
            },
            loadData(){
                if(!this.callTableList || this.callTableList.length == 0){
                    if(this.isLocalData){
                        if(this.getCallData){
                            this.getCallData().then(res => {
                                this.setLocalData(res);
                            })
                        }
                    }else {
                        this.$global.getTransferTable(this.tableName, this.defaultExtra).then((res) => {
                            this.callTableList = res;
                        });
                    }
                }
            }
        },
        created(){
            if('small' == this.callType){
                this.nameWidth = 50;
                this.nameML = -46;
            }

            if(this.isSelfWidth){
                this.nameWidth = this.labelWidth;
            }
            this.callTableInit();
        },
        watch: {
            queryVal(val){
                if(this.inpDialog){
                    this.queryEnter();
                }
            }
        },
        updated(){
            if(this.showLabel){
                if(this.inpLable){
                    let spanWidth = this.$refs['callInput'].$el.children[1].children[0].children[1].children[0].offsetWidth;
                    if(spanWidth && spanWidth > this.nameWidth){
                        this.tooldis = false;
                    }else{
                        this.tooldis = true;
                    }
                }else{
                    this.tooldis = true;
                }
            }
        },
        beforeDestroy(){
            this.tableData = [];
            this.callTableList = [];
            this.componentShow = false;
        }
    };
</script>
<style>
</style>



// WEBPACK FOOTER //
// ../../src/components/zmCallTable/index.vue